import { ACKNOWLEDGE_CLOSURE, ACKNOWLEDGE_CLOSURE_SUCCESS, ACKNOWLEDGE_CLOSURE_ERROR, ACKNOWLEDGE_CLOSURE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AcknowledgeClosure = (state = initialState, action) => {
  switch (action.type) {
    case ACKNOWLEDGE_CLOSURE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ACKNOWLEDGE_CLOSURE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ACKNOWLEDGE_CLOSURE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ACKNOWLEDGE_CLOSURE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AcknowledgeClosure;
